export default "__VITE_ASSET__p8tE4ohi__"